import { ChangeDetectorRef, Directive, Input, OnDestroy, OnInit, Optional, Self } from "@angular/core";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { AppOnlineStateService } from "@main/pwa/app-online-state.service";
import { FormButtonsComponent } from "@mipro/components";
import { Button, ButtonDirective } from "primeng/button";
import { SplitButton } from "primeng/splitbutton";
import { filter, Subject, takeUntil } from "rxjs";

@Directive({
    selector: "p-button, button[pButton], p-splitButton"
})
export class DisableButtonOfflineDirective implements OnDestroy, OnInit {
    private element: { disabled: boolean };
    private disabledState: boolean;
    private destroyed$ = new Subject<void>();

    @Input() allowOffline: any;

    @Input() set disabled(disabled: boolean) {
        this.disabledState = disabled;
        this.shouldDisable ? this.setDisableAppOnline(this.onlineService.isAppOnline) : this.setDisable(disabled);
    }

    constructor(
        private broadcastService: BroadcastService,
        private cd: ChangeDetectorRef,
        private onlineService: AppOnlineStateService,
        @Optional() @Self() pButton: ButtonDirective,
        @Optional() @Self() button: Button,
        @Optional() @Self() splitButton: SplitButton
    ) {
        this.element = button ?? splitButton ?? pButton?.el?.nativeElement;
        this.setupOnLineChange();
    }

    ngOnInit(): void {
        if (this.shouldDisable) {
            this.setDisableAppOnline(this.onlineService.isAppOnline);
        }
    }

    ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    private setupOnLineChange() {
        this.broadcastService
            .on<{ isAppOnline: boolean }>(AppOnlineStateService.AppOnlineStateChanged)
            .pipe(
                takeUntil(this.destroyed$),
                filter(_ => this.shouldDisable)
            )
            .subscribe(({ isAppOnline }) => {
                this.setDisableAppOnline(isAppOnline);
                this.cd.detectChanges();
            });
    }

    private get shouldDisable() {
        return this.allowOffline == null && !!this.element;
    }

    private setDisableAppOnline(isAppOnline: boolean) {
        const nextDisabled = isAppOnline ? this.disabledState : true;
        this.setDisable(nextDisabled);
    }

    private setDisable(disabled: boolean) {
        this.element.disabled = disabled;
    }
}
